import { FC, useContext, useEffect, useState } from "react";
import { Layout, MasterCard, MasterTable, PageTitle } from "../components";
import logo from "../assets/logo.svg";
import { Master } from "../types";
import config from "../config";
import $api from "../http";
import { Context } from "..";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

const SelectMaster: FC<{ title: string }> = observer(({ title }) => {
  const { store } = useContext(Context);
  const navigate = useNavigate();

  const [masters, setMasters] = useState<Master[]>();
  const [selectedMaster, setSelectedMaster] = useState<Master>();

  useEffect(() => {
    if (!store.isAuth) return navigate("/");

    if (!store.masters) {
      $api.get(`${config.API}/master/all`).then(({ data }) => {
        store.setMasters(data.data);
        setMasters(data.data);
      });
    } else {
      setMasters(store.masters);
    }
  }, [navigate, store]);

  useEffect(() => {
    if(selectedMaster) {
      store.setSelectedMaster(selectedMaster);
      navigate("/default/services");
    }
  }, [selectedMaster, navigate, store]);

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={128} height={128} />
      <PageTitle>Выбор мастера</PageTitle>
      <MasterTable>
      {masters &&
          masters.map((e: Master) => (
            <MasterCard key={e.name} name={e.name} photo={`${config.API}/${e.photo}`} stat={e.stat} onClick={() => setSelectedMaster(e)} />
          ))}
      </MasterTable>
    </Layout>
  );
});

export default SelectMaster;
